const containsName = (entity, searchString) => {
  const contains = entity.name && entity.name.toUpperCase().includes(searchString)
  console.log('containsName', contains)
  return contains
}

const containsRichText = (entity, searchString) => {
  const contains = entity.richText && entity.richText.toUpperCase().includes(searchString)
  console.log('containsRichText', contains)
  return contains
}

export default {
  data () {
    return {
      searchString: ''
    }
  },
  methods: {
    search (entities = [], searchString = '') {
      searchString = searchString.toUpperCase()
      console.log('Searchstring', searchString)
      console.log('Entities', entities)
      return entities.filter(
        e => containsName(e, searchString) || containsRichText(e, searchString)
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/search.mixin.js